import { useState, forwardRef, useMemo } from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ListItemText,
  ListSubheader,
  TextField,
  InputAdornment
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { dropdownProps } from 'src/models/leave';

interface SingleSelectProps {
  title?: string;
  formControlClass?: string;
  placeholder?: string;
  isSearch?: boolean;
  dropdownList: dropdownProps[] | [],
  value: any,
  onChange: (e: any) => void,
  onClick?: () => void
}

const SingleSelect = forwardRef((props: SingleSelectProps, _ref) => {
  const placeholderStyle = {
    color: 'rgba(34, 51, 84, 0.7)',
    fontSize: '12px',
    fontStyle: 'normal'
  }
  const [list] = useState<dropdownProps[]>(props?.dropdownList);
  const [searchText, setSearchText] = useState<string>('');

  //search list by name
  const containsText = (text, searchText) =>
    text?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1;

  const filteredList = useMemo(
    () =>
      list.length > 0 &&
      list?.filter((option) => containsText(option?.name, searchText)),
    [list, searchText]
  );

  return (
    <FormControl fullWidth 
      className={props?.formControlClass ? props?.formControlClass : ''}>
      {props?.title &&
        <InputLabel
          style={{
            fontSize: '12px'
          }}
        >
          {props?.title}
        </InputLabel>
      }
      <Select
        sx={{ mt: 1 }}
        style={{
          fontSize: '12px',
          height: '2rem'
        }}
        displayEmpty
        fullWidth
        size="small"
        value={props?.value}
        onChange={(e) => props?.onChange(e)}
        onClose={() => setSearchText('')}
        renderValue={(selected) => {
          if (selected === '' && props?.placeholder) {
            return <em style={placeholderStyle}>{props?.placeholder}</em>;
          }
          return selected?.name;
        }}
        onClick={() => props.onClick && props.onClick()} 
      >
        {props?.isSearch &&
        <ListSubheader>
          <TextField
            id="search-dropdown"
            size="small"
            autoFocus
            placeholder="Type to search..."
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            onChange={(e) => setSearchText(e.target.value)}
            onClick={(e) => {
              e.stopPropagation();
            }}
            onKeyDown={(e) => {
              if (e.key !== 'Escape') {
                e.stopPropagation();
              }
            }}
          ></TextField>
        </ListSubheader>}
        {
          filteredList?.length > 0 &&
          filteredList.map((item, index) => {
            return (
              <MenuItem key={index} 
                value={item as any }>
                  <ListItemText key={index} primary={item?.name} />
              </MenuItem>
            );
          })
        }
      </Select>
    </FormControl>
  );
});

export default SingleSelect;
